module.exports = __webpack_public_path__ + "img/Coin BankC01.d043166e.png";